// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__13KMC","container":"styles_container__50eT4","title":"styles_title__9F7BA","wrapper":"styles_wrapper__2PLoK","answer":"styles_answer__1sSoC"};